const names = ["dratini", "dragonite", "mewtwo","beedrill","metapod","blastoise","abra","pidgeotto","digglet","nidorina","articuno","hypno","kabutops","magnemite","onix"]


export default function createUserObject() {
    return {
        user: true,
        "lvl": 20,
        "gender": "male",
        "name": names[Math.floor(Math.random() * (names.length))],
        "originalTrainer": "Tu vieja",
        "IDNo": 33591,
        "item": "",
        "nature": "modest",
        "location": "Trade",
        "foundLvl": 4,
        "currentStats": {
            "HP": 100,
            "MaxHP": 100,
            "ATTACK": 100,
            "DEFENSE": 100,
            "SPATTACK": 100,
            "SPDEFENSE": 100,
            "SPEED": 100
        },
        "exp": {
            "currentExp": 6629,
            "toNextLvl": 7000
        },
        "movesKnown": [32,15,36,12],
    }
}
